export default function hashTableToArray(object) {
  const arr = [];

  Object.values(object).forEach(val => {
    arr.push(val);
  });

  return arr;
}
